import { useParams } from "react-router-dom";
import { useFetchMilestoneTaskViewQuery } from "../../../slice/logdetailSlice";
import { CommonShowDocument } from "../../common/AddDocumentComponent";


const MilestoneTaskListDocument = () => {
  const { id: taskId } = useParams();
  const { refetch } = useFetchMilestoneTaskViewQuery(taskId);

  return (
    <>
      <CommonShowDocument
        refetchList={refetch}
        showPath="milestones/task/document"
        downloadPath="milestones/task/document/document/download"
        deletePath="milestones/task/document"
        type="milestones/task"
      />
    </>
  );
};

export default MilestoneTaskListDocument;
